module.exports = __webpack_public_path__ + "img/sv12.ab586083.svg";